import { useState } from 'react'
import { Modal } from 'shared'
import { Formik, Field, Form } from 'formik'
import { JSONFetcher, Button, FormTextArea, FormCentsInput, formatCents } from 'shared'

export const ExternalDonationButton = (props) => {
  const [showModal, setShowModal] = useState(false)
  const [data, setData] = useState(props)
  const hideModal = () => setShowModal(false)
  const openModal = () => setShowModal(true)

  return <>
    <button className='nowrap desktop:mr-2 simulated-link' onClick={openModal}>{I18n.t('modules.need_editor.external_donation')}</button>

    <Modal
      id='external-donation-modal'
      onHide={hideModal}
      show={showModal}
      header={I18n.t('modules.need_editor.external_donation_modal_headline')}
    >
      <p>{I18n.t('modules.need_editor.external_donation_introduction')}</p>
      <FormContent {...data} setData={setData} closeModal={hideModal} />
    </Modal>
  </>
}

const FormContent = (props) => {
  const initialValues = {
    amount_in_cents: 0,
    comment: ''
  }

  // TODO: There should be a way to pass validation rules from ActiveRecord to React. Will check that out.
  const maxCommentLength = 250

  const submitHandler = (values, formikBag) => {
    JSONFetcher.post({
      url: props.externalDonationsUrl,
      body: { external_donation: values },
      success: (resp) => {
        if (resp.errors) {
          let errors = {}
          resp.errors.forEach(error => {
            // We assert that `error` is a string starting with the name of the field it refers to.
            const [subject] = error.split(' ', 1)
            const issue = error.slice(subject.length + 1)
            switch (subject) {
              case 'Comment':
                errors.comment = issue
                break
              case 'Amount':
                errors.amount_in_cents = issue
                break
            }
          })
          formikBag.setErrors(errors)
          formikBag.setSubmitting(false)
        } else {
          window.location.reload()
        }
      }
    })
  }

  const validate = (values) => {
    const errors = {}
    if (values.amount_in_cents <= 0) errors.amount_in_cents = I18n.t('misc.required_field')
    else if (values.amount_in_cents > props.stillNeededAmount) errors.amount_in_cents = I18n.t('errors.messages.less_than_or_equal_to', { count: props.stillNeededAmount / 100 })
    if (values.comment.length > maxCommentLength) errors.comment = I18n.t('errors.messages.too_long')
    return errors
  }

  return <Formik
    initialValues={initialValues} onSubmit={submitHandler} validate={validate}>
    {formikProps => <Form>
      <Field
        name='amount_in_cents'
        label={I18n.t('modules.need_editor.external_donation_amount_label')}
        // TODO: Would be cool to have sth. like this: max={props.stillNeededAmount}
        hint={I18n.t('modules.need_editor.external_donation_amount_hint', { still_needed_amount: formatCents(props.stillNeededAmount) })}
        component={FormCentsInput} />

      <Field
        name='comment'
        label={I18n.t('modules.need_editor.external_donation_comment_label')}
        component={FormTextArea}
        maxLength={maxCommentLength}
        rows={3} />

      <Button type='submit' loading={formikProps.isSubmitting} className='btn-large btn-primary'>
        {I18n.t('verbs.save')}
      </Button>
    </Form>}
  </Formik>
}
